module.exports = __webpack_public_path__ + "img/mobile/Background/portrait_paytable_background@1.5x.jpg?1.1.2";